import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { request } from "../utill";
import LoadingSpinner from "../components/LoadingSpinner";
import localforage from "localforage";
import { toast } from "react-toastify";

const Orders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true); 

  const getData = async () => {
    console.log('HERE')
    try {
      setLoading(true); 
      console.log('before')
      const res = await request("/esalat-user/orders");
      console.log(res)
      if(res.status === 'unauthorized'){
        await localforage.removeItem("jwt");
        toast.success("لطفا وارد شوید.", { rtl: true });
        return navigate("/login");
      }
      setOrders(res.data);
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoading(false); 
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const formatToPersianDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("fa-IR", {
      calendar: "persian",
      day: "numeric",
      month: "numeric",
      year: "numeric",
    }).format(date);
  };

  const calculateProgress = (startDate, endDate) => {
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    const now = Date.now();
    const totalDuration = end - start;
    const elapsed = now - start;
    const progress = (totalDuration / elapsed) * 100;
    return Math.min(Math.max(progress, 0), 100);
  };

  const getProgressBarColor = (progress) => {
    if (progress < 33) return "#f44336"; 
    if (progress < 66) return "#ffeb3b"; 
    return "#4caf50"; 
  };

  return (
    <Layout>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="w-100">
          <h1 className="login-title">لیست خرید های من</h1>

          <table className="table-wrapper">
            <thead>
              <tr>
                <th>نام کالا</th>
                <th>کد کالا</th>
                <th>شناسه کالا</th>
                <th>تاریخ شروع</th>
                <th>تاریخ پایان</th>
                <th>مدت زمان باقی‌مانده</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => {
                const progress = calculateProgress(
                  order.activation_start_date,
                  order.activation_end_date
                );
                return (
                  <tr key={order.id}>
                    <td data-label="نام کالا">{order.name}</td>
                    <td data-label="کد کالا">{order.product_code}</td>
                    <td data-label="شناسه کالا">{order.product_identifier}</td>
                    <td data-label="تاریخ شروع">
                      {formatToPersianDate(order.activation_start_date)}
                    </td>
                    <td data-label="تاریخ پایان">
                      {formatToPersianDate(order.activation_end_date)}
                    </td>
                    <td data-label="مدت زمان باقی‌مانده">
                      <div className="progress-bar">
                        <div
                          className="progress-bar-fill"
                          style={{
                            width: `${progress}%`,
                            backgroundColor: getProgressBarColor(progress),
                          }}
                        ></div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      <div className="login-footer w-100">
        <button
          onClick={() => navigate(-1)}
          className="AZ-primary-btn d-flex align-items-center justify-content-center w-100"
        >
          بازگشت
        </button>
      </div>
    </Layout>
  );
};

export default Orders;
